export default __webpack_public_path__ + "static/media/1_1_5.871cb4b8.png";